@if (portEntry) {
  <div class="fieldset" [ngClass]="{'disabled' :firstBerthVisit.ata || firstBerthVisit.atd}">
    @if (!portEntry.entryDependency?.vesselName) {
      <div class="row">
        <div class="col">
          @if (hasFirstBerth() && portEntry.origin === 'SEA') {
            <app-form-group>
              <label for="select-dependency">Dependency on vessel</label>
              <app-select id="select-dependency" [(ngModel)]="dependencyType" [options]="dependencyOptions"
                          [formatter]="dependencyFormatter" [refreshWatch]="firstBerthVisit.berth.berthGroupCode"
                          (ngModelChange)="resolveDependency($event)">
              </app-select>
            </app-form-group>
          }
        </div>
      </div>
    }
    @if (portEntry.origin === 'SEA' && portEntry.entryDependency) {
      <div class="row">
        <div class="declaration-block col-md-12">
          @if (portEntry.entryDependency.dependencyType === 'ENTRY_AFTER' && !portEntry.entryDependency.vesselName) {
            <app-form-group
            >
              <app-info class="formGroupLabel">
                <label for="entry-after-vessel">Select vessel</label>
                <span class="tooltipContent">Only vessels that are already arrived or will arrive within 48 hours of the
                  chosen ETA pilot boarding place will be shown.
                  Vessels that have already been selected by different agents can not be selected.
                Please contact the terminal if you want to select one of these.</span>
              </app-info>
              <app-search id="entry-after-vessel" [ngModel]="dependentVisit"
                          (ngModelChange)="setEntryDependency($event)"
                          required [minCharacters]="1" [searchFunction]="refreshVisitsForEntryAfter"
                          [styling]="styleEntryAfter"
                          [inputFormatter]="entryAfterFormatter">
              </app-search>
            </app-form-group>
          }
          @if (portEntry.entryDependency.dependencyType === 'EXCHANGE' && !portEntry.entryDependency.vesselName) {
            <app-form-group
            >
              <app-info class="formGroupLabel">
                <label for="entry-after-vessel">Select vessel</label>
                <span class="tooltipContent">Vessels that have already been selected by different agents can not be
                  selected.
                Please contact the terminal if you want to select one of these.</span>
              </app-info>
              <app-search id="exchange-vessel" [ngModel]="dependentVisit" (ngModelChange)="setEntryDependency($event)"
                          required [minCharacters]="1" [searchFunction]="refreshVisitsForExchange"
                          [styling]="styleExchange"
                          [inputFormatter]="exchangeFormatter">
              </app-search>
            </app-form-group>
          }
          @if (portEntry.entryDependency && portEntry.entryDependency.vesselName) {
            <div>
              <app-form-group>
                @if (portEntry.entryDependency.dependencyType === 'EXCHANGE') {
                  <label>Exchange with</label>
                }
                @if (portEntry.entryDependency.dependencyType === 'ENTRY_AFTER') {
                  <label>Entry after</label>
                }
                <div class="card">
                  <div class="card-body text-secondary py-1" [ngClass]="{'bg-light': context.isArrived()}">
                    <div class="row">
                      @if (appContext.isAdmin()) {
                        <div class="col px-1"><a
                          [href]="['/details/' + portEntry.entryDependency.crn]"
                          target="_blank">{{ portEntry.entryDependency.vesselName }}
                          - {{ portEntry.entryDependency.crn }}</a>
                        </div>
                      }
                      @if (!appContext.isAdmin()) {
                        <div class="col px-1">{{ portEntry.entryDependency.vesselName }}</div>
                      }
                      <span class="col-auto pull-right clickable pe-0 me-1" title="Remove"
                            (click)="removeDependencyOnVessel()"
                            [ngClass]="{'disabled' : 'DECLARED' === context.declarationStatusOf(VISIT)}"><i
                        class="fa fa-times"></i></span>
                    </div>
                    @if (portEntry.entryDependency.berthName) {
                      <div class="row">
                        <div>
                          <div class="col px-1">{{ portEntry.entryDependency.berthName }} -
                            {{ portEntry.entryDependency.berthCode }}
                          </div>
                        </div>
                      </div>
                    }
                    <div class="row">
                      <div class="col px-1">
                        {{ formatTime(portEntry.entryDependency) }}
                      </div>
                      @if (portEntry.entryDependency.movementOnHold) {
                        <div class="col text-end px-1">ON HOLD</div>
                      }
                      @if (!portEntry.entryDependency.movementOnHold && portEntry.entryDependency.orderStatus) {
                        <div
                          class="col text-end px-1">
                          Order:
                          <span>
                          @switch (portEntry.entryDependency.orderStatus) {
                            @case ('ORDERED') {
                              <span style="vertical-align: text-bottom;"
                                    class="badge bg-portbase-light-blue">
                                <span class="fa fa-paper-plane text-white"></span>
                              </span>
                            }
                            @case ('REEVALUATED') {
                              <span style="vertical-align: text-bottom;"
                                    class="badge bg-portbase-light-blue">
                                <span class="fa fa-paper-plane text-white"></span>
                              </span>
                            }
                            @case ('REJECTED') {
                              <span style="vertical-align: text-bottom;"
                                    class="badge bg-portbase-red bg-light">
                                <span class="fa fa-times text-white"></span>
                              </span>
                            }
                            @case ('CANCELLED') {
                              <span style="vertical-align: text-bottom;"
                                    class="badge bg-portbase-red bg-light">
                                <span class="fa fa-times text-white"></span>
                              </span>
                            }
                            @case ('CONFIRMED') {
                              <span style="vertical-align: text-bottom;"
                                    class="badge bg-portbase-green">
                                <span class="fa fa-check text-white"></span>
                              </span>
                            }
                            @case ('ETA_CHANGED') {
                              <span style="vertical-align: text-bottom;" class="badge text-bg-warning">
                                <span class="fa fa-check text-white"></span>
                              </span>
                            }
                            @case ('ETD_CHANGED') {
                              <span style="vertical-align: text-bottom;" class="badge text-bg-warning">
                                <span class="fa fa-check text-white"></span>
                              </span>
                            }
                          }
                        </span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </app-form-group>
            </div>
          }
          @if (showAutomaticOrder && portEntry.entryDependency.vesselName) {
            <app-form-group>
              <app-info class="formGroupLabel">
                <label>Auto-order</label>
                @if (portEntry.entryDependency.dependencyType === 'EXCHANGE') {
                  <span class="tooltipContent">
                The incoming vessel is automatically ordered when the departing vessel is ordered.</span>
                }
                @if (portEntry.entryDependency.dependencyType === 'ENTRY_AFTER') {
                  <span class="tooltipContent">
                The incoming vessel is automatically ordered when the other arriving vessel is ordered.</span>
                }
              </app-info>
              <app-yes-no required [(ngModel)]="portEntry.entryDependency.autoOrder"
                          (ngModelChange)="orderIncomingMovementIfRequired($event)">
              </app-yes-no>
            </app-form-group>
          }
        </div>
      </div>
    }
  </div>
}
